/*eslint-disable sort-keys */
import { itemSortOrders } from './';

const savedItemSortOrders = {
    ...itemSortOrders,
    SAVED_RECENT_FIRST: 'SAVED_RECENT_FIRST',
    SAVED_OLDEST_FIRST: 'SAVED_OLDEST_FIRST',
} as const;

export default savedItemSortOrders;
